export default {
    stateTriggers: [
        {
            startingTriggers: [
                {
                    statePath: "Window.TimeoutWarning.visible",
                    operator: "equal",
                    value: true,
                },
                {
                    statePath: "Survey.visible",
                    operator: "equal",
                    value: true,
                },
                {
                    statePath: "Window.EndChatWarning.visible",
                    operator: "equal",
                    value: true,
                },
            ],
            operator: "or",
            setValueStatePaths: [
                "Window.AlmeMessage.shouldDisable",
                "Window.DisplayLinks.shouldDisable",
                "Window.DisplayLinksUrl.shouldDisable",
                "Window.InputBoxLocked.isInputBoxLocked",
                "Window.NavUrl.shouldDisable",
                "Window.SkipToContent.shouldDisable",
                "Window.UserMessage.shouldDisable",
            ],
            setObjectStatePaths: [
                "Window.CallToActionButtons.shouldDisable",
                "Window.InlineSurveyLinks.shouldDisable",
            ],
            toValue: true,
        },
        {
            startingTriggers: [
                {
                    statePath: "Window.TimeoutWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Survey.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Window.EndChatWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
            ],
            operator: "and",
            setValueStatePaths: [
                "Window.AlmeMessage.shouldDisable",
                "Window.UserMessage.shouldDisable",
            ],
            setObjectStatePaths: [
            ],
            toValue: false,
        },
        {
            startingTriggers: [
                {
                    statePath: "LiveChat.SessionState",
                    operator: "equal",
                    value: "Online",
                },
                {
                    statePath: "LiveChat.SessionState",
                    operator: "equal",
                    value: "Queued",
                },
            ],
            operator: "or",
            setValueStatePaths: [
                "Window.DisplayLinks.shouldDisable",
                "Window.NavUrl.shouldDisable",
                "Window.SkipToContent.shouldDisable",
            ],
            setObjectStatePaths: [
                "Window.CallToActionButtons.shouldDisable",
                "Window.InlineSurveyLinks.shouldDisable",
            ],
            toValue: true,
        },
        {
            startingTriggers: [
                {
                    statePath: "LiveChat.SessionState",
                    operator: "notEqual",
                    value: "Online",
                },
                {
                    statePath: "LiveChat.SessionState",
                    operator: "notEqual",
                    value: "Queued",
                },
                {
                    statePath: "Window.TimeoutWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Survey.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Window.EndChatWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
            ],
            operator: "and",
            setValueStatePaths: [
                "Window.DisplayLinks.shouldDisable",
                "Window.DisplayLinksUrl.shouldDisable",
                "Window.NavUrl.shouldDisable",
                "Window.SkipToContent.shouldDisable",
            ],
            setObjectStatePaths: [
                "Window.CallToActionButtons.shouldDisable",
                "Window.InlineSurveyLinks.shouldDisable",
            ],
            toValue: false,
        },
        {
            startingTriggers: [
                {
                    statePath: "LiveChat.SessionState",
                    operator: "equal",
                    value: "Queued",
                },
            ],
            operator: "or",
            setValueStatePaths: [
                "Window.InputBoxLocked.isInputBoxLocked",
            ],
            setObjectStatePaths: [],
            toValue: true,
        },
        {
            startingTriggers: [
                {
                    statePath: "LiveChat.SessionState",
                    operator: "notEqual",
                    value: "Queued",
                },
                {
                    statePath: "Window.TimeoutWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Survey.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Window.EndChatWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
            ],
            operator: "and",
            setValueStatePaths: [
                "Window.InputBoxLocked.isInputBoxLocked",
            ],
            setObjectStatePaths: [],
            toValue: false,
        },

    ],
};



// WEBPACK FOOTER //
// ./settings/state-triggers.ts